/**
 * Created by adderlyjaureguicampos on 03/01/17.
 */
const React = require('react');
const PropTypes = require('prop-types');
const { RadioButton } = require('commonsComponents/radioButton');
const ContractRiskButtonGroup = require('../ContractRiskButtonGroup/ContractRiskButtonGroup');
const { StarsRating } = require('commonsComponents/starsRating');
const { FormattedText } = require('core/i18n').i18n;
require('./InvestmentFundList.scss');

class InvestmentFundList extends React.Component {

    constructor(props) {
        super(props);
        this.buildOptions = this.buildOptions.bind(this);

        this.investmentOptions = [
            {
                id: 1,
                label: 'Alberdeen Global - Japanese Equity Fund',
                category: 'Renta variable zona euro',
                ratingStars: 5
            },
            {
                id: 2,
                label: 'Groupama Avenir Euro N',
                category: 'Renta variable zona euro',
                ratingStars: 3
            }
        ];
        let initialState;
        if (this.props.values) {
            initialState = this.props.values
        } else {
            initialState = {
                investmentFund: 1,
                component_id: 'investmentFundList'
            };
        }
        this.state = initialState;

        this.handleRadioOnChange = this.handleRadioOnChange.bind(this);
    }

    buildOptions() {
        return this.investmentOptions.map((investmentFund, index) => {
            return (
                <div className="contracts-investment-funds" key={index}>
                    <div className="inline-element">
                        <RadioButton
                            key={index}
                            id={"investmentFund" + investmentFund.id}
                            name="investmentFund"
                            label={investmentFund.label}
                            value={investmentFund.id}
                            isChecked={this.state.investmentFund === investmentFund.id}
                            onChange={this.handleRadioOnChange}
                        />
                        <p className="contracts-investment-funds__category"><FormattedText
                            value="contractsView-investmentFundCategory"/> {investmentFund.category}</p>
                    </div>
                    <div className="inline-element morningstar pull-right">
                        <p><FormattedText value="contractsView-investmentFundRatMorningstar"/></p>
                        <StarsRating total={5} actual={investmentFund.ratingStars}/> {/*@hardcoded*/}
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {/*YTD 1A 3A 5A*/}
                            <div className="contracts-investment-funds__table-container">
                                <table className="contracts-investment-funds__table">
                                    <thead>
                                        <tr>
                                            <th>YTD</th>
                                            <th>1 A</th>
                                            <th>3 A</th>
                                            <th>5 A</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>5.11</td>
                                            <td>12.28</td>
                                            <td>9.85</td>
                                            <td>3.19</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <ContractRiskButtonGroup lowRisk={1} highRisk={7} risk={4}/> {/*@hardcoded (until service integration)*/}
                        </div>
                    </div>

                </div>);
        });

    }

    handleRadioOnChange(selectedValue) {
        this.setState({investmentFund: parseInt(selectedValue)});
    }

    render() {
        this.props.dataReceiver(this.state);
        const options = this.buildOptions();
        return (
            <div>
                <h3><FormattedText value="contractsView-investmentFundSelect"/></h3>
                <form >
                    {options}
                </form>
            </div>
        );
    }
}

InvestmentFundList.propTypes = {
    values: PropTypes.object,
    dataReceiver: PropTypes.func,
    investmentFunds: PropTypes.array
};

module.exports = InvestmentFundList;
